{
  "metadata": {
    "id": "palenight-light",
    "name": "Palenight",
    "description": "Портировано из темы «Palenight» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "palenight.json",
      "project": "whizkydee",
      "url": "https://github.com/whizkydee/vscode-palenight-theme",
      "upstreamFile": "packages/ui/src/theme/themes/palenight.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 26.7,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.462,
      "paletteMaxS": 0.538,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 20.5,
      "syntaxVsTextMinDeltaE": 18.5,
      "chartsMinDeltaE": 25.4,
      "textSeparationDeltaE": 12.0,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#4976eb",
      "hover": "#426ad4",
      "active": "#3c61c1",
      "foreground": "#000000",
      "muted": "#4976eb80",
      "emphasis": "#4976eb"
    },
    "surface": {
      "background": "#fafafa",
      "foreground": "#292d3e",
      "muted": "#cbccd1",
      "mutedForeground": "#3c485c",
      "elevated": "#b4b6bd",
      "elevatedForeground": "#292d3e",
      "raised": "#999ba4",
      "raisedForeground": "#292d3e",
      "overlay": "#fafafa33",
      "subtle": "#e2e3e5"
    },
    "interactive": {
      "border": "#91939d",
      "borderHover": "#bfc1c5",
      "borderFocus": "#4976eb",
      "selection": "#292d3e24",
      "selectionForeground": "#292d3e",
      "focus": "#4976eb59",
      "focusRing": "#4976eb47",
      "cursor": "#292d3e",
      "hover": "#292d3e17",
      "active": "#292d3e24"
    },
    "status": {
      "error": "#df211d",
      "errorForeground": "#ffffff",
      "errorBackground": "#df211d1a",
      "errorBorder": "#df211d59",
      "warning": "#996b00",
      "warningForeground": "#ffffff",
      "warningBackground": "#996b001a",
      "warningBorder": "#996b0059",
      "success": "#5e7b35",
      "successForeground": "#ffffff",
      "successBackground": "#5e7b351a",
      "successBorder": "#5e7b3559",
      "info": "#d53b0a",
      "infoForeground": "#ffffff",
      "infoBackground": "#d53b0a1a",
      "infoBorder": "#d53b0a59"
    },
    "pr": {
      "open": "#5e7b35",
      "draft": "#49576f",
      "blocked": "#996b00",
      "merged": "#009eb2",
      "closed": "#df211d"
    },
    "syntax": {
      "base": {
        "background": "#cbccd1",
        "foreground": "#292d3e",
        "comment": "#49576f",
        "keyword": "#7910d5",
        "string": "#465b27",
        "number": "#9f2c08",
        "function": "#005f6a",
        "variable": "#292d3e",
        "type": "#704f00",
        "operator": "#005f6a"
      },
      "tokens": {
        "commentDoc": "#49576f",
        "stringEscape": "#005f6a",
        "keywordImport": "#7910d5",
        "storageModifier": "#7910d5",
        "functionCall": "#005f6a",
        "method": "#005f6a",
        "variableProperty": "#005f6a",
        "variableOther": "#292d3e",
        "variableGlobal": "#9f2c08",
        "variableLocal": "#005f6a",
        "parameter": "#292d3e",
        "constant": "#9f2c08",
        "class": "#704f00",
        "className": "#704f00",
        "interface": "#704f00",
        "struct": "#704f00",
        "enum": "#704f00",
        "typeParameter": "#704f00",
        "namespace": "#704f00",
        "module": "#7910d5",
        "tag": "#7910d5",
        "jsxTag": "#7910d5",
        "tagAttribute": "#005f6a",
        "tagAttributeValue": "#465b27",
        "boolean": "#9f2c08",
        "decorator": "#7910d5",
        "label": "#005f6a",
        "regexp": "#465b27"
      }
    },
    "charts": {
      "series": [
        "#4976eb",
        "#d53b0a",
        "#5e7b35",
        "#996b00",
        "#c26a3a"
      ]
    },
    "chat": {
      "background": "#fafafa",
      "userMessage": "#292d3e",
      "userMessageBackground": "#b4b6bd",
      "assistantMessage": "#292d3e",
      "assistantMessageBackground": "#cbccd1",
      "timestamp": "#49576f",
      "divider": "#91939d",
      "typing": "#49576f"
    },
    "loading": {
      "spinner": "#4976eb",
      "spinnerTrack": "#cbccd1",
      "skeleton": "#cbccd1",
      "shimmer": "#c1c2c8"
    },
    "tools": {
      "background": "#cbccd1",
      "border": "#91939d",
      "headerHover": "#c3c4ca",
      "icon": "#3768e9",
      "title": "#292d3e",
      "description": "#49576f",
      "edit": {
        "added": "#5e7b35",
        "addedBackground": "#5e7b351a",
        "removed": "#df211d",
        "removedBackground": "#df211d1a",
        "modified": "#d53b0a",
        "modifiedBackground": "#d53b0a1a",
        "lineNumber": "#49576f"
      }
    },
    "markdown": {
      "heading1": "#292d3e",
      "heading2": "#292d3e",
      "heading3": "#292d3e",
      "heading4": "#292d3e",
      "link": "#3768e9",
      "linkHover": "#426ad4",
      "inlineCode": "#465b27",
      "inlineCodeBackground": "#cbccd1",
      "blockquote": "#49576f",
      "blockquoteBorder": "#91939d",
      "listMarker": "#4473ea",
      "bold": "#292d3e",
      "italic": "#292d3ee6",
      "strikethrough": "#49576f",
      "hr": "#91939d"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c45364",
        "foreground": "#000000",
        "contrast": 4.77
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d3ad93",
        "foreground": "#000000",
        "contrast": 10.17
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#a9753f",
        "foreground": "#000000",
        "contrast": 5.3
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dcde94",
        "foreground": "#000000",
        "contrast": 14.92
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#82a34c",
        "foreground": "#000000",
        "contrast": 7.29
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#65ca5c",
        "foreground": "#000000",
        "contrast": 10.16
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#92dc9f",
        "foreground": "#000000",
        "contrast": 12.96
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#4da28d",
        "foreground": "#000000",
        "contrast": 6.87
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#91d0db",
        "foreground": "#000000",
        "contrast": 12.25
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#44799e",
        "foreground": "#ffffff",
        "contrast": 4.69
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4e6fc1",
        "foreground": "#ffffff",
        "contrast": 4.81
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3038a0",
        "foreground": "#ffffff",
        "contrast": 9.55
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9852c1",
        "foreground": "#ffffff",
        "contrast": 4.87
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c68cd7",
        "foreground": "#000000",
        "contrast": 8.13
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#a63d83",
        "foreground": "#ffffff",
        "contrast": 5.81
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d191a7",
        "foreground": "#000000",
        "contrast": 8.32
      }
    ]
  }
}
